import React, { useEffect, useState } from "react";
import { StyledSectionContainer } from "styles/components";
import HeaderContainer from "styles/components/headerContainer";
import { StyledSectionContainerWhiteWrapper } from "styles/components/SectionContainer/index.styles";
import { useTheme } from "@mui/material/styles";

import Result from "pages/Blog/components/ImprovedBlogResults";
import CBLoading from "components/CBLoading";
import { useLocation } from "react-router-dom";
import { fetchBlogsByModality } from "utils/api/payloadCMS";

const FeaturedBlogs = ({ ...props }) => {
  const location = useLocation();
  const { highlightText, highlightColor } = props;
  const modalityType = location.pathname.split("/")[1];

  const theme = useTheme();
  const { titleH2, description } = props;
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadBlogs = async () => {
      setLoading(true);
      setError(null);

      try {
        const blogData = await fetchBlogsByModality(modalityType);
        setBlogs(blogData.slice(0, 3));
      } catch (error) {
        console.error("Error fetching blogs:", error);
        setError("Failed to load featured blogs");
        setBlogs([]);
      } finally {
        setLoading(false);
      }
    };

    loadBlogs();
  }, [modalityType]);

  return (
    <StyledSectionContainerWhiteWrapper id={`almadelic-${modalityType}-blog`}>
      <StyledSectionContainer>
        <HeaderContainer
          title={titleH2}
          description={description}
          component={"h2"}
          variant={"h2"}
          highlightText={highlightText}
          highlightColor={highlightColor || theme.palette.accent.main}
          cssProps={{ marginTop: "0rem !important", marginBottom: { xs: "1rem !important", md: "2rem !important" } }}
          textColor={theme.palette.primary.main}
        />

        {loading ? (
          <CBLoading />
        ) : error ? (
          <div style={{ textAlign: "center", padding: "2rem", color: "red" }}>{error}</div>
        ) : (
          <Result blogs={blogs} cssProps={{ padding: "0rem !important" }} headerType="h3" />
        )}
      </StyledSectionContainer>
    </StyledSectionContainerWhiteWrapper>
  );
};

export default FeaturedBlogs;
